import ownershipErrorCodes from "../../enums/errorCodes/ownership";
export default function (code) {
    switch (code) {
        case ownershipErrorCodes.InvalidParam:
            return "errors.PBOWN1033E";
        case ownershipErrorCodes.AmountNotInteger:
            return "errors.PBOWN1034E";
        case ownershipErrorCodes.EmptyCurrency:
            return "errors.PBOWN1035E";
        case ownershipErrorCodes.InvalidReason:
            return "errors.PBOWN1036E";
        case ownershipErrorCodes.InvalidJSON:
            return "errors.PBOWN1037E";
        case ownershipErrorCodes.AdminUserUuidNotRetrievable:
            return "errors.PBOWN1038E";
        case ownershipErrorCodes.InvalidCurrency:
            return "errors.PBOWN1039E";
        case ownershipErrorCodes.SystemWalletNotRetrievable:
            return "errors.PBOWN1040E";
        case ownershipErrorCodes.UserWalletNotRetrievable:
            return "errors.PBOWN1041E";
        case ownershipErrorCodes.TransferCreationError:
            return "errors.PBOWN1042E";
        case ownershipErrorCodes.MissingAuthToken:
            return "errors.PBOWN1043E";
        case ownershipErrorCodes.AmountGreaterThanBalance:
            return "errors.PBOWN1063E";
        default:
            return "";
    }
}
